<template>
<el-container>
  <el-dialog :show-close="true" :title="$t('confirmTitle')" :visible.sync="openCancel" :width="diaWidth" :close-on-click-modal="false" :close-on-press-escape="false" @close="closeCancelDia">
    <!--注销帐号提示信息弹窗-->
    <div class="dia_confirm" v-if="confirmShow">
      <div class="icon">
        <img src="/static/img/account/cancelAccountNotice.png" class="iconImage"/>
      </div>
      <div class="confirmContent">
        {{ $t('logoutAccountConfirm')}}<br/>
        <b>{{ $t('pleaseNote') }}</b>
        {{ $t('logoutConfirmText') }}
      </div>
      <div class="button">
        <el-button class="cancelBtn" @click="closeCancelDia"> {{ $t('buttonCancel') }}</el-button>
        <el-button class="confirmBtn" @click="sendConfirmCode">{{ $t('confirm') }}</el-button>
      </div>
    </div>
    <!--注销帐号确认验证码弹窗-->
    <div class="dia_code_confirm" v-if="codeConfirmShow">
      <div class="confirmCodeContent">
        {{$t(confirmCodeText)}}
        <input type="text" autocomplete="off" class="el-input__inner" ref="confirmCode" :placeholder="$t('inputMobileCode')" style="margin-top: 20px">
      </div>
      <div class="button">
        <el-button class="cancelBtn" @click="closeCancelDia">{{ $t('buttonCancel') }}</el-button>
        <el-button class="confirmBtn" @click="doCancel">{{ $t('confirm') }}</el-button>
      </div>
    </div>
  </el-dialog>
  <el-dialog class="logoutSuccess" :show-close="true" :title="$t('logoutAccountSuccess')" :visible.sync="cancelAccountSuccess" :width="diaWidth" :close-on-click-modal="false" :close-on-press-escape="false" @close="cancelSuccess">
    <!--{注销帐号成功弹窗}-->
    <div class="dia-success">
      <div class="successContent">{{ $t('lookingForwardAgain') }}</div>
      <el-button class="confirmBtn" @click="cancelSuccess">{{ $t('confirm') }}</el-button>
    </div>
  </el-dialog>
</el-container>
</template>

<script>
import { orderCancel } from '@/request/user.js'
export default {
  name: 'CancelAccount',
  props: ['openCancel', 'source', 'language', 'conver'],
  components: {
    orderCancel
  },
  data () {
    return {
      ismobile: false,
      showClo: false,
      diaWidth: '500px',
      confirmShow: true,
      codeConfirmShow: false,
      confirmCodeText: '',
      cancelAccountSuccess: false,
      sendConfirmCodeStatus: false,
      doCancelStatus: false,
      dialogTitle: 'confirmTitle'
    }
  },
  watch: {},
  created () {},
  mounted () {
    if (document.documentElement.clientWidth < 1001) {
      this.ismobile = true
      this.diaWidth = '95%'
    } else {
      this.ismobile = false
      this.diaWidth = '500px'
    }
  },
  methods: {
    closeCancelDia () {
      this.openCancel = false
      this.confirmShow = true
      this.codeConfirmShow = false
      this.$emit('dialog-closed', false)
    },
    sendConfirmCode () {
      if (this.sendConfirmCodeStatus === true) {
        console.log('重复点击')
        return
      }
      var newQuerys = this.common.linkEncode({'source': this.source}, 'obj')
      if (this.conver === 1 || this.conver === '1') {
        newQuerys = this.common.linkEncode({'source': this.source, 'conver': this.conver}, 'obj')
      }
      var time = parseInt(new Date().getTime() / 1000)
      var token = localStorage.getItem('token')
      if (token === undefined || token === null) {
        let locationHref = window.document.location.href
        sessionStorage.setItem('LoginWebsiteAddress', locationHref)
        this.$router.push({name: 'login', params: {'querys': newQuerys}})
        return
      }
      this.sendConfirmCodeStatus = true
      var sessionid = this.common.sessionidGet(this)
      var dataJson = {
        'time': time,
        'token': token,
        'sessionid': sessionid,
        'source': this.source,
        'language': this.language,
        'operation': 'sendCancelCode'
      }
      var data = this.common.encryptionData(dataJson, this)
      orderCancel(data).then(res => {
        console.log(res)
        this.sendConfirmCodeStatus = false
        if (res.flag === '001') {
          let locationHref = window.document.location.href
          sessionStorage.setItem('LoginWebsiteAddress', locationHref)
          this.$router.push({name: 'login', params: {'querys': newQuerys}})
        } else if (res.flag === '210' || res.flag === '211') { // 向邮箱 或 手机号 发送了6位验证码.
          this.confirmCodeText = res.msg
          this.confirmShow = false
          this.codeConfirmShow = true
        } else if (res.flag === '200') { // 无邮箱和手机号，跳过验证码录入逻辑，直接删除成功.
          this.cancelSuccessShow()
        } else {
          this.$message({
            type: 'error',
            message: this.$t(res.msg)
          })
          if (res.flag === '101') { // 有未处理的订单，跳转订单列表.
            setTimeout(() => {
              this.$router.push({name: 'MyTrip', params: {'querys': newQuerys}})
            }, 3000)
          }
        }
      })
    },
    doCancel () {
      if (this.doCancelStatus === true) {
        console.log('重复点击')
        return
      }
      let code = this.$refs['confirmCode'].value
      if (code === '') {
        this.$refs['confirmCode'].focus()
        return
      }
      let token = localStorage.getItem('token')
      if (token === undefined || token === null) {
        let locationHref = window.document.location.href
        sessionStorage.setItem('LoginWebsiteAddress', locationHref)
        let newQuerys = this.common.linkEncode({'source': this.source}, 'obj')
        if (this.conver === 1 || this.conver === '1') {
          newQuerys = this.common.linkEncode({'source': this.source, 'conver': this.conver}, 'obj')
        }
        this.$router.push({name: 'login', params: {'querys': newQuerys}})
      }
      this.doCancelStatus = true
      let time = parseInt(new Date().getTime() / 1000)
      let sessionid = this.common.sessionidGet(this)
      let dataJson = {
        'time': time,
        'token': token,
        'sessionid': sessionid,
        'code': code,
        'operation': 'doCancel'
      }
      let data = this.common.encryptionData(dataJson, this)
      orderCancel(data).then(res => {
        this.doCancelStatus = false
        if (res.flag === '001') {
          let newQuerys = this.common.linkEncode({'source': this.source}, 'obj')
          if (this.conver === 1 || this.conver === '1') {
            newQuerys = this.common.linkEncode({'source': this.source, 'conver': this.conver}, 'obj')
          }
          this.$router.push({name: 'login', params: {'querys': newQuerys}})
        } else if (res.flag === '200') {
          this.cancelSuccessShow()
        } else {
          this.$message({
            type: 'error',
            message: this.$t(res.msg)
          })
        }
      })
    },
    cancelSuccessShow () {
      this.openCancel = false
      this.cancelAccountSuccess = true
      localStorage.removeItem('token')
    },
    cancelSuccess () {
      // 跳转到首页.
      let newQuerys = this.common.linkEncode({'source': this.source}, 'obj')
      if (this.conver === 1 || this.conver === '1') {
        newQuerys = this.common.linkEncode({'source': this.source, 'conver': this.conver}, 'obj')
      }
      this.$router.push({name: 'Home', params: {'querys': newQuerys}})
    }
  },
  computed: {}
}
</script>

<style>
.el-dialog__body {
  padding-top: 5px !important;
}
.logoutSuccess .el-dialog__header {
  text-align: center;
}
.el-dialog__title {
  font-weight: 500;
}
</style>

<style scoped>
.icon {
  height: 140px;
  width: 20px;
  float: left;
}
.iconImage {
  width: 20px;
  box-sizing: border-box;
}

.confirmContent {
  font-size: 14px;
  background-color: rgba(255, 255, 255, 0);
  box-sizing: border-box;
  font-family: 'PingFangSC-Regular', 'PingFang SC', sans-serif;
  color: #4f4c4c;
  text-align: left;
  line-height: normal;
}

.button {
  margin-top: 10px;
  text-align: right;
}

.confirmBtn {
  width: 80px;
  font-size: 16px;
  padding: 9px 10px 9px 10px;
  border-radius: 6px;
  background-color: #5392f9;
  box-sizing: border-box;
  font-family: 'PingFangSC-Regular', 'PingFang SC', sans-serif;
  color: #ffffff;
  text-align: center;
  line-height: normal;
}
.confirmBtn:hover {
  background-color: #3e6cea;
  box-sizing: border-box;
}
.confirmBtn:active {
  background-color: #3e6cea;
  box-sizing: border-box;
}

.cancelBtn {
  width: 80px;
  font-size: 16px;
  padding: 9px 10px 9px 10px;
  border-radius: 6px;
  background-color: rgba(83, 146, 249, 0);
  box-sizing: border-box;
  font-family: 'PingFangSC-Regular', 'PingFang SC', sans-serif;
  color: #5392f9;
  text-align: center;
  line-height: normal;
}
.cancelBtn:hover {
  box-sizing: border-box;
  color: #3e6cea;
}
.cancelBtn:active {
  box-sizing: border-box;
  color: #3e6cea;
}

.dia_code_confirm {
  height: 187px;
}
.confirmCodeContent {
  height: 135px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.dia-success {
  text-align: center;
}

.dia-success .confirmBtn {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/account/module/CancelAccount.vue